export const enum ContractedRateType {
  AllIn = 'flat',
  LineHaulFSC = 'lhfsc',
}
